module.exports = __webpack_public_path__ + "img/Pic_Ks_ZWSJ.6397dc7e.png";